module.exports = __webpack_public_path__ + "img/im_dinner.e1537583.png";